export const sanitizeString = (string = '') => {
  // eslint-disable-next-line no-useless-escape
  const SEARCH_INPUT_REGEX = /[^a-zA-Z\u00C0-\u00FF0-9\s\-\.\_\'\&\"\!\$\@\+]/g;
  return string.trim().replace(SEARCH_INPUT_REGEX, '');
};
